import { Question } from './question';
import { QuizDto } from './quiz.dto';

export class Quiz {
    readonly id: string;
    readonly name: string;
    readonly questions: Question[];

    constructor(data: QuizDto) {
        this.id = data.id ?? '';
        this.name = data.name ?? '';
        this.questions = data.questions?.map((question) => new Question(question)) ?? [];
    }
}
